import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const campaignAffiliatesSelector = createFeatureSelector<IState>('campaignAffiliate');
export const getcampaignAffiliatesSelector = createSelector(campaignAffiliatesSelector, (state: IState) => state); 
export const getcampaignAffiliateSelector = createSelector(campaignAffiliatesSelector, (state: IState) => state.selectedItem); 
